import {UseQueryResult,useQuery} from "@tanstack/react-query";
import {ComparableMetric,ComparableValuationResponse,fetchEquityComparables} from "@features/investments/api";
export const comparableQueryKey=(ticker:string,metric?:ComparableMetric)=>["investments","comparables",ticker,metric??"default"] as const;
export function useEquityComparablesQuery(ticker:string,metric:ComparableMetric|undefined,enabled=true):UseQueryResult<ComparableValuationResponse,Error>{
  return useQuery({queryKey:comparableQueryKey(ticker,metric),queryFn:()=>fetchEquityComparables(ticker,metric),enabled:enabled&&ticker.trim()!=="",retry:false});
}
